<template>
    <section v-if="props.modelValue" class="modal">
        <article class="modal__content">
            <h4 class="modal__title">Editar Usuario</h4>
            <form class="modal__form">
                <span>
                    <input class="basic-slide" id="usuario" type="text" placeholder="Escribe el Nombre" /><label
                        for="usuario" autocomplete="off">Usuario</label>
                </span>
                <span>
                    <input class="basic-slide" id="pass" type="password" placeholder="Contraseña" /><label for="pass"
                        autocomplete="off">Contraseña</label>
                </span>
                <span>
                    <input class="basic-slide" id="confirm_pass" type="confirm_password"
                        placeholder="Confirmar Contraseña" /><label for="confirm_pass" autocomplete="off">Confirmar
                        Contraseña</label>
                </span>
                <!--switch button de activo o inactivo-->
                <div class="group-switch">
                    <input type="checkbox" id="switch">
                    <label for="switch" class="switch"></label>
                </div>

                <div class="modal__separator">
                    <button type="submit" class="save-button">Guardar</button>
                </div>
            </form>

            <button class="modal__close" @click="closeModal">&times;</button>
        </article>
    </section>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: Boolean
});

const emit = defineEmits(['update:modelValue']);

const closeModal = () => {
    emit('update:modelValue', false);
};
</script>

<style scoped>

.group-switch {
    margin: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    font-family: Arial, sans-serif;
}

.switch {
    display: flex;
    align-items: center;
    position: relative;
    width: 120px;
    height: 30px;
    background: #76b5a0;
    border-radius: 15px;
    cursor: pointer;
    transition: background 0.3s ease;
    color: white;
    font-size: 14px;
    font-weight: bold;
    justify-content: center;
}

input[type="checkbox"] {
    display: none;
}

.switch::before {
    content: "Activo";
    position: absolute;
    transition: 0.3s ease;
}

.switch::after {
    content: "";
    position: absolute;
    left: 5px;
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    transition: 0.3s ease;
}

input:checked+.switch {
    background: #d33649;
}

input:checked+.switch::before {
    content: "Inactivo";
}

input:checked+.switch::after {
    left: 95px;
}
</style>